var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Results", {
    attrs: {
      sourceAPI: _vm.finametricaSourceAPI,
      riskToleranceView: _vm.riskToleranceView,
      region: _vm.region,
      lang: _vm.lang,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }